var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { StringParam, useQueryParams, DelimitedArrayParam } from 'use-query-params';
import { motion } from 'framer-motion';
import InfiniteScroll from 'react-infinite-scroll-component';
import CardSearch from '../../components/Card/Search';
import axiosInstance from '../../config/axios';
import classNames from 'classnames';
import Drawer from '../../components/Drawer';
import Heading from '../../components/Typography/Heading';
import { useForm } from 'react-hook-form';
import { ChevronRight, Search as SearchIcon, Download, X, Info, Sliders, MapPin, } from 'react-feather';
import { Shape2, WhiteLoupe } from '../../components/CustomIcon';
import TextInput from '../../components/Fields/TextInput';
import Button from '../../components/Button';
import Location from '../../components/Fields/Location';
import { api } from '../../config/api';
import MultiSelectFull from '../../components/Fields/MultiSelect/Full';
import RangeSlider from '../../components/Fields/RangeSlider';
import { toast } from 'react-toastify';
import { ValidationString } from '../../hooks/useValidation';
import FadeUp from '../../components/Animation/FadeUp';
import Paragraph from '../../components/Typography/Paragraph';
import Seo from '../../components/Seo';
import { useCardOffset } from '../../hooks/useCardOffset';
import { useBookmark } from '../../hooks/useBookmark';
import { debounce } from 'lodash';
var classes = {
    accordion: {
        base: 'cursor-pointer py-6 px-drawer border-t border-gray-300 flex items-center justify-between group',
        content: 'flex items-center gap-4',
        title: 'text-lg font-medium md:text-xl',
        count: 'bg-brand-01 h-6 w-6 rounded-full text-white text-center flex items-center justify-center text-xs',
        icon: 'transition-transform group-hover:-translate-x-2',
    },
};
var container = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.05,
        },
    },
};
var listItem = {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
};
var Search = function () {
    var _a, _b, _c, _d;
    var locationString = useLocation();
    var navigate = useNavigate();
    var _e = useCardOffset(), handleOffset = _e.handleOffset, handleClasses = _e.handleClasses;
    var _f = useBookmark(), saveBookmark = _f.saveBookmark, bookmarkLoading = _f.loading, getCount = _f.getCount;
    var filterAccordions = [
        { title: 'Localisation', key: 'location' },
        { title: 'Métiers', key: 'jobs' },
        { title: 'Compétences', key: 'skills' },
        { title: 'Genres musicaux', key: 'musical_genres' },
        { title: 'Programmes / Partenariats', key: 'programs' },
    ];
    var _g = useState(false), ready = _g[0], setReady = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var _j = useState(), programsDescription = _j[0], setProgramsDescription = _j[1];
    var _k = useState(false), savedBookmark = _k[0], setSavedBookmark = _k[1];
    var _l = useState({
        jobs: [],
        skills: [],
        musical_genres: [],
        programs: [],
    }), categories = _l[0], setCategories = _l[1];
    var _m = useState({
        main: false,
        location: false,
        jobs: false,
        skills: false,
        musical_genres: false,
        programs: false,
    }), drawers = _m[0], setDrawers = _m[1];
    var _o = useState({
        users: [],
        total: 0,
        page: 1,
        perPage: 10,
    }), results = _o[0], setResults = _o[1];
    var _p = useQueryParams({
        name: StringParam,
        location: StringParam,
        radius: StringParam,
        jobs: DelimitedArrayParam,
        skills: DelimitedArrayParam,
        musical_genres: DelimitedArrayParam,
        programs: DelimitedArrayParam,
    }), query = _p[0], setQuery = _p[1];
    var _q = useState(1), page = _q[0], setPage = _q[1];
    var name = query.name, location = query.location, radius = query.radius, jobs = query.jobs, skills = query.skills, musical_genres = query.musical_genres, programs = query.programs;
    var _r = useForm({
        defaultValues: {
            name: name && name !== '' ? name : undefined,
            location: location ? { address: location } : undefined,
            radius: location && radius ? Number(radius) : 0,
        },
    }), handleSubmit = _r.handleSubmit, control = _r.control, watch = _r.watch, reset = _r.reset, getValues = _r.getValues, setValue = _r.setValue;
    var handleLoadMore = function () {
        var newPage = (page !== null && page !== void 0 ? page : 1) + 1;
        setPage(newPage);
        handleQuery(function (response) {
            setResults({
                users: __spreadArray(__spreadArray([], results.users, true), response.data.users, true),
                total: response.data.total,
                page: response.data.page,
                perPage: response.data.perPage,
            });
        }, newPage);
    };
    var handleReset = function () {
        setDrawers(__assign(__assign({}, drawers), { main: false }));
        setQuery({}, 'replace');
        setPage(1);
        reset({
            name: '',
            location: null,
            radius: 0,
            jobs: [],
            skills: [],
            musical_genres: [],
        });
    };
    var handleQuery = function (callback, page) {
        var showLoader = !(page && page > 1);
        showLoader && setLoading(true);
        axiosInstance
            .post(api.search.query(locationString.search), { page: page !== null && page !== void 0 ? page : 1 })
            .then(function (response) {
            callback(response);
        })
            .catch(function (error) {
            toast.error(ValidationString.GLOBAL);
        })
            .finally(function () {
            showLoader && setLoading(false);
        });
    };
    var countActiveFilters = function () {
        return (query &&
            Object.keys(query).filter(function (key) { return key !== 'page' && query[key] !== undefined; })
                .length);
    };
    var formatMultiSelect = function (values) {
        if (!values)
            return undefined;
        var formattedValues = values.map(function (value) {
            return value.id;
        });
        return formattedValues.length ? formattedValues : undefined;
    };
    var handleDefaultCategory = function (selected, categories) {
        if (!selected || !categories)
            return;
        var filter = [];
        categories.forEach(function (item) {
            item.children.forEach(function (child) {
                if (selected.includes(child.id)) {
                    filter.push(child);
                }
            });
        });
        return filter;
    };
    var onSubmit = function (data) {
        var _a;
        setPage(1);
        setQuery({
            name: data.name && data.name !== '' ? data.name : undefined,
            location: (_a = data.location) === null || _a === void 0 ? void 0 : _a.address,
            radius: data.location && data.radius && data.radius > 0 ? data.radius : undefined,
            jobs: formatMultiSelect(data.jobs),
            skills: formatMultiSelect(data.skills),
            musical_genres: formatMultiSelect(data.musical_genres),
            programs: formatMultiSelect(data.programs),
        });
        setDrawers(__assign(__assign({}, drawers), { main: false }));
    };
    var debouncedSubmit = useCallback(debounce(function (data) {
        handleSubmit(onSubmit)(data);
    }, 600), []);
    // Gère la mise à jour des paramètres de recherche (filtres)
    useEffect(function () {
        handleQuery(function (response) {
            setResults({
                users: response.data.users,
                total: response.data.total,
                page: response.data.page,
                perPage: response.data.perPage,
            });
        });
    }, [query]);
    // Gère la récupération des jobs, skills et musical_genres
    useEffect(function () {
        axiosInstance.get(api.categories.all).then(function (_a) {
            var data = _a.data;
            axiosInstance.get(api.content.all).then(function (content) {
                setProgramsDescription(content.data.programs);
                setCategories(data);
                setValue('jobs', handleDefaultCategory(jobs, data.jobs));
                setValue('skills', handleDefaultCategory(skills, data.skills));
                setValue('musical_genres', handleDefaultCategory(musical_genres, data.musical_genres));
                setValue('programs', handleDefaultCategory(programs, data.programs));
                setReady(true);
            });
        });
    }, []);
    if (!ready) {
        return (<div className="flex-center h-full min-h-[calc(100vh-120px)] w-full bg-brand-01">
        <Shape2 size={80} className="animate-spin"/>
      </div>);
    }
    return (<>
      <Seo title="Annuaire"/>
      <div className="flex h-full min-h-[calc(100vh-120px)] w-full flex-col bg-brand-01">
        <div className={classNames('z-40 bg-white py-4', 'lg:fixed lg:bottom-8 lg:left-1/2 lg:-translate-x-1/2 lg:transform lg:rounded-3xl lg:px-4 lg:w-max', 'max-lg:sticky max-lg:top-0 max-lg:left-0 max-lg:w-full max-lg:overflow-x-auto')}>
          <div className="flex gap-4 max-lg:container items-center">
            <Paragraph className="uppercase font-semibold max-lg:hidden">Filtrer par :</Paragraph>
            <button onClick={function () { return setDrawers(__assign(__assign({}, drawers), { main: true, location: true })); }} className="flex-none rounded-md bg-white border border-brand-01 px-2 py-2 text-sm text-gray-500 flex items-center whitespace-nowrap w-40 lg:w-64">
              <MapPin className="text-brand-01 flex-none mr-2" size={16}/>
              {watch('location') ? (<>
                  <span className="truncate">{watch('location').address}</span>
                  {watch('radius') ? ' - ' + watch('radius') + ' km' : ''}
                </>) : (<>
                  <span className="mr-2">Localisation</span>
                  <ChevronRight className="text-brand-01 ml-auto flex-none" size={18}/>
                </>)}
            </button>

            <form className="" onChange={debouncedSubmit} onSubmit={function (e) { e.preventDefault(); }}>
              <TextInput name="name" className="w-40 md:w-auto" control={control} iconStart size="sm" placeholder="Prénom, nom d'artiste..." icon={SearchIcon} required/>
            </form>
            <div onClick={function () { return setDrawers(__assign(__assign({}, drawers), { main: true })); }} className="flex whitespace-nowrap w-fit cursor-pointer items-center gap-2 rounded-lg bg-secondary-04 py-2 px-4 text-center transition-colors hover:bg-secondary-04-dark">
              <Sliders size={18}/>
              Autres filtres
              {countActiveFilters() > 0 && (<span className="flex h-5 w-5 items-center justify-center rounded-full bg-brand-02 text-xs text-white">
                  {countActiveFilters()}
                </span>)}
            </div>
            {/*  <div
          onClick={() => navigate('/favoris')}
          className="flex w-fit cursor-pointer items-center gap-2 rounded-lg border border-brand-01 py-2 px-4 text-center transition-colors hover:bg-brand-01 hover:text-white"
        >
          Mes recherches
          {getCount()
            ? getCount() > 0 && (
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-brand-02 text-xs text-white">
                  {getCount()}
                </span>
              )
            : null}
        </div> */}
          </div>
        </div>

        {countActiveFilters() > 0 && !loading && (<div className="w-full bg-secondary-01 py-4">
            <div className="container">
              <div className="relative w-fit">
                <div className="dark flex items-center gap-2 md:gap-4">
                  <Paragraph className="max-md:text-xs">{"".concat(results.total, " r\u00E9sultat").concat(results.total > 1 ? 's' : '', " pour vos crit\u00E8res")}</Paragraph>
                  <Button onClick={function () {
                return saveBookmark(locationString.search, function () { return setSavedBookmark(true); });
            }} size="sm" className="whitespace-nowrap" type="outlined" icon={Download} side="start" loading={bookmarkLoading}>
                    Sauvegarder ma recherche
                  </Button>
                </div>
                {savedBookmark && (<div className="absolute top-[130%] right-0 z-100 flex flex-col items-start gap-4 rounded-lg bg-white p-4">
                    <X size={16} className="absolute top-4 right-4 cursor-pointer" onClick={function () { return setSavedBookmark(false); }}/>
                    <Paragraph bold>Votre recherche est sauvegardée !</Paragraph>
                    <Paragraph size="xs" className="md:w-3/4">
                      Vous pouvez retrouver vos sauvegardes dans la page “Mes recherches”
                    </Paragraph>
                    <Button onClick={function () { return navigate('/favoris'); }} type="inline" icon={ChevronRight}>
                      Voir mes recherches
                    </Button>
                  </div>)}
              </div>
            </div>
          </div>)}

        {loading && (<div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <Shape2 size={80} className="animate-spin"/>
          </div>)}
        {((_a = results === null || results === void 0 ? void 0 : results.users) === null || _a === void 0 ? void 0 : _a.length) > 0 && !loading && (<InfiniteScroll dataLength={results.users.length} next={handleLoadMore} hasMore={(results === null || results === void 0 ? void 0 : results.total) > ((_b = results === null || results === void 0 ? void 0 : results.users) === null || _b === void 0 ? void 0 : _b.length)} className="w-full pb-28 lg:pb-40" loader={<div className="loader flex-center w-full py-6" key={0}>
                <Shape2 size={40} className="animate-spin"/>
              </div>}>
            <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-1 gap-x-6 px-6 pb-10 sm:grid-cols-2 lg:grid-cols-6 lg:pt-10 xl:grid-cols-12 max-sm:gap-8 max-lg:pt-14 3xl:grid-cols-[repeat(20,minmax(0,1fr))]">
              {(_c = results === null || results === void 0 ? void 0 : results.users) === null || _c === void 0 ? void 0 : _c.map(function (result, index) {
                return (<motion.div key={index} className={classNames('flex', handleClasses(index))} variants={listItem}>
                    <FadeUp>
                      <CardSearch user={result} offset={handleOffset(index)}/>
                    </FadeUp>
                  </motion.div>);
            })}
            </motion.div>
          </InfiniteScroll>)}

        {((_d = results === null || results === void 0 ? void 0 : results.users) === null || _d === void 0 ? void 0 : _d.length) == 0 && !loading && (<div className="flex h-full w-full flex-1 items-center pt-8 pb-28 lg:pt-10 lg:pb-40">
            <div className="container">
              <FadeUp>
                <div className="dark mx-auto flex max-w-[680px] flex-col items-center text-center">
                  <WhiteLoupe size={118} className="max-md:h-20 max-md:w-20"/>
                  <Heading level={5} className="mt-6">
                    Aucun profil ne semble correspondre à votre recherche.
                  </Heading>
                  <Paragraph className="mt-4">
                    Pour trouver plus de profils inspirants, vous pouvez :
                  </Paragraph>
                  <div className="mt-4 flex flex-col gap-2">
                    <Paragraph>- Supprimer quelques filtres</Paragraph>
                    <Paragraph>- Élargir votre rayon de recherche</Paragraph>
                    <Paragraph>
                      - Indiquer le prénom/nom exact du profil que vous recherchez
                    </Paragraph>
                  </div>
                  <Button type="outlined" onClick={handleReset} className="mt-6" loading={loading}>
                    Réinitialiser ma recherche
                  </Button>
                </div>
              </FadeUp>
            </div>
          </div>)}
      </div>
      <Drawer handleClose={function () { return setDrawers(__assign(__assign({}, drawers), { main: false })); }} open={drawers.main}>
        <div className="px-drawer">
          <Heading level={2} type="h5">
            Tous les filtres
          </Heading>
        </div>
        <form className="mt-10 pb-32" onSubmit={handleSubmit(onSubmit)}>
          <div className="px-drawer pb-6">
            <TextInput name="name" control={control} label="Rechercher par nom ou nom d'artiste" placeholder="Ex : Camille Martin" icon={SearchIcon} bigLabel required/>
          </div>

          {filterAccordions.map(function (accordion) {
            var _a, _b;
            return (<div key={accordion.key} className={classes.accordion.base} onClick={function () {
                var _a;
                return setDrawers(__assign(__assign({}, drawers), (_a = {}, _a[accordion.key] = true, _a)));
            }}>
                <div className={classes.accordion.content}>
                  <div className={classes.accordion.title}>{accordion.title}</div>
                  {accordion.tooltip ? (<Info size={20} className="cursor-pointer px-1 text-gray-500" onClick={function () { }}/>) : null}
                  {((_a = getValues(accordion.key)) === null || _a === void 0 ? void 0 : _a.length) ? (<div className={classes.accordion.count}>
                      {(_b = getValues(accordion.key)) === null || _b === void 0 ? void 0 : _b.length}
                    </div>) : null}
                  {accordion.key === 'location' && watch('location') && (<div className="flex gap-1 text-[12px] text-white bg-brand-01 py-1 px-2 rounded">
                      <span className="truncate block max-w-[100px] lg:max-w-[140px]">
                        {watch('location').address}
                      </span>
                      {watch('radius') ? ' - ' + watch('radius') + ' km' : ''}
                    </div>)}
                </div>
                <ChevronRight className={classes.accordion.icon} size={24}/>
              </div>);
        })}

          <div className="px-drawer absolute bottom-0 left-0 flex w-full gap-6 bg-white py-6 whitespace-nowrap shadow-sticky">
            <Button type="outlined" onClick={handleReset} className="flex-1" loading={loading}>
              Réinitialiser
            </Button>
            <Button className="flex-1" submit loading={loading}>
              Voir les profils
            </Button>
          </div>
        </form>
      </Drawer>

      <Drawer handleClose={function () { return setDrawers(__assign(__assign({}, drawers), { location: false })); }} open={drawers.location}>
        <div className="px-drawer">
          <div className="flex flex-col gap-4 lg:px-20 lg:mt-20 lg:gap-6">
            <Heading level={2} type="h5">
              Localisation
            </Heading>
            <Location name="location" control={control} placeholder="Ex : Paris, Lyon..." required/>
            {watch('location') && (<RangeSlider min={0} max={200} name="radius" label="Dans un rayon autour de" control={control} defaultValue={radius !== null && radius !== void 0 ? radius : 0}/>)}
            <div className="px-drawer absolute bottom-0 left-0 w-full bg-white py-6 flex items-center justify-center shadow-sticky gap-6">
              <Button type="outlined" className="lg:min-w-[176px]" onClick={function () { return setDrawers(__assign(__assign({}, drawers), { location: false })); }}>
                Annuler
              </Button>
              <Button className="lg:min-w-[176px]" onClick={function () {
            setDrawers(__assign(__assign({}, drawers), { location: false }));
        }}>
                Valider la localisation
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
      <MultiSelectFull name="jobs" control={control} categories={categories.jobs} title="Métiers" open={drawers.jobs} handleClose={function () { return setDrawers(__assign(__assign({}, drawers), { jobs: false })); }} noResults="Vos métiers apparaîtront ici"/>
      <MultiSelectFull name="skills" control={control} categories={categories.skills} title="Compétences" open={drawers.skills} handleClose={function () { return setDrawers(__assign(__assign({}, drawers), { skills: false })); }} noResults="Vos compétences apparaîtront ici"/>
      <MultiSelectFull name="musical_genres" control={control} categories={categories.musical_genres} title="Genres musicaux" open={drawers.musical_genres} handleClose={function () { return setDrawers(__assign(__assign({}, drawers), { musical_genres: false })); }} noResults="Vos genres musicaux apparaîtront ici" enableCategoriesSelection={true}/>
      <MultiSelectFull name="programs" control={control} categories={categories.programs} title="Programmes / Partenariats" open={drawers.programs} handleClose={function () { return setDrawers(__assign(__assign({}, drawers), { programs: false })); }} noResults="Vos programmes / partenariats apparaîtront ici" wysiwyg={programsDescription}/>
    </>);
};
export default Search;
